import React from 'react';
import { twMerge } from 'tailwind-merge';

export function IconCircle({ onClick, className, color = 'currentColor', strokeWidth = '2.5' }) {
  return (
    <svg
      onClick={onClick}
      className={twMerge('w-6 h-6', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="8"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
